import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import ExamplePdf from '../../assets/FixtureSampleFile.csv'
import ExamplePdfIndoor from '../../assets/FixtureSampleFileIndoor.csv'
import FixtureService from 'src/service/FixtureService'
import CommonService from 'src/service/CommonService'

const ImportFixture = () => {
  const [file, setFile] = useState()
  const [array, setArray] = useState([])
  const [gameType, setGameType] = useState()
  const [errorMessages, setErrorMessages] = useState([]) // State to manage error messages
  const fileReader = new FileReader()

  useEffect(() => {
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])

  useEffect(() => {
    if (array.length > 0 && gameType !== null) {
      const FixtureCSVData = { fixtureData: array }

      const handleResponse = (res) => {
        if (res.success) {
          ToastComponent(res.message, 'success')
          setErrorMessages([]) // Clear error messages on success
        } else {
          const errors =
            res.errors && Array.isArray(res.errors)
              ? res.errors
              : [res.message || 'Something went wrong.']
          setErrorMessages(errors) // Update error messages
          // ToastComponent(res.message, 'error')
        }
      }

      if (gameType == 1) {
        FixtureService.fixtureImport(FixtureCSVData).then(handleResponse)
      } else {
        FixtureService.importFixtureForIndoor(FixtureCSVData).then(handleResponse)
      }
    }
  }, [array, gameType])

  const handleOnChange = (e) => {
    setFile(e.target.files[0])
  }

  const csvFileToArray = (string) => {
    const csvHeader = string.slice(0, string.indexOf('\n')).split(',')
    const csvRows = string.slice(string.indexOf('\n') + 1).split('\n')

    const array = csvRows.map((i) => {
      const values = i.split(',')
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index]
        return object
      }, {})
      return obj
    })

    setArray(array)
  }

  const handleImportPlayer = (e) => {
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result
        csvFileToArray(text)
      }
      fileReader.readAsText(file)
    } else {
      ToastComponent('Please upload a CSV file.', 'error')
    }
  }

  return (
    <>
      {errorMessages.length > 0 && (
        <div className="error-list">
          {errorMessages.map((error, index) => (
            <>
              {/* <li key={index}>{error}</li> */}
              <CAlert color="danger" key={index}>
                {error}
              </CAlert>
            </>
          ))}
        </div>
      )}
      <CRow className="pt-2">
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>Fixture Import</strong>
            </CCardHeader>

            <CCardBody>
              <CRow>
                <CCol md={6}>
                  <CFormInput
                    type="file"
                    id="playerFileId"
                    name="playerFileName"
                    accept={'.csv'}
                    onChange={handleOnChange}
                  />
                </CCol>
                <CCol md={6}>
                  <CLoadingButton color="success" variant="outline" onClick={handleImportPlayer}>
                    Run Import
                  </CLoadingButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>Download Sample File</strong>
              <br></br>
            </CCardHeader>

            <CCardBody>
              <CRow>
                <CCol md={12}>
                  <p>
                    <p>
                      Easily add multiple fixtures by using the fixtures import tool. Simply create
                      your fixtures list in a CSV (Comma Separated Values) format using the format
                      defined below. Once your file is ready, upload your CSV file and click
                      &apos;Import Fixtures&apos; button.
                    </p>
                  </p>
                  <p>
                    {' '}
                    <a
                      href={gameType == 1 ? ExamplePdf : ExamplePdfIndoor}
                      download="Fixture-Sample-CSV.csv"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <CButton color={'primary'} variant="outline">
                        Download Sample CSV
                      </CButton>
                    </a>
                  </p>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>Key Points</strong>
            </CCardHeader>

            <CCardBody>
              <CRow>
                <CCol md={12}>
                  <>
                    <div>
                      <ul>
                        <li>
                          Team code can be found next to the Team Name created in the Teams section
                        </li>
                        <li>
                          Valid Match Types are:
                          <ul>
                            <li>1-Day</li>
                            <li>2-Day</li>
                          </ul>
                        </li>
                        <li>
                          Valid Start Date format is:
                          <ul>
                            <li>DD.MM.YYYY</li>
                          </ul>
                        </li>
                        <li>
                          Valid End Date format is:
                          <ul>
                            <li>DD.MM.YYYY</li>
                          </ul>
                        </li>
                        <li>
                          Valid Start Time format is (12-Hr Format):
                          <ul>
                            <li>H.MM AM or H.MM PM</li>
                          </ul>
                        </li>
                        <li>
                          Valid End Time format is:
                          <ul>
                            <li>H.MM AM or H.MM PM</li>
                          </ul>
                        </li>
                        <li>
                          Start Date and Start Time of a Fixture MUST be within the Start Date/Start
                          Time and End Time of a Round
                        </li>
                        <li>
                          Required fields are Team Code, Match Type, Start Date, End Date, Start
                          Time, End Time
                        </li>
                        <li>There must be no blank spaces in the 6 required fields</li>
                        <li>
                          Import function will not process in case of error in the information on
                          the import file
                        </li>
                      </ul>

                      <p>
                        Once the Fixture list has been imported, you can edit and change all fixture
                        information by going to the Fixture List (under Fixture tab).
                      </p>

                      <p>
                        <strong>File Format</strong>
                      </p>

                      <p>
                        HEADINGS REQUIRED in the first row of your CSV file. Each row of your file
                        MUST start with Team Code information in each row (for example below,
                        Columns are separated by a comma (,)):
                      </p>

                      <ul>
                        <li>team_code, match_type, start_date, end_date, start_time, end_time</li>
                        <li>T00033, 1-Day, 27.09.2023, 27.09.2023, 4.40 PM, 4.50 PM</li>
                        <li>T00034, 2-Day, 27.09.2023, 28.09.2023, 4.40 PM, 4.50 PM</li>
                      </ul>
                    </div>
                  </>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default ImportFixture
